import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HexLockup } from '../../../components/FieldCertLogo';
import { LANDING_CONTENT } from '../content';

const SCROLL_THRESHOLD = 8;

/**
 * Sticky marketing nav. Owns its own scrolled state (used only to fade in the
 * bottom border) and the responsive collapse — below 768px the section anchors
 * and the sign-in link drop away, leaving the lockup and one primary button.
 */
export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const { anchors, signIn, cta } = LANDING_CONTENT.nav;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > SCROLL_THRESHOLD);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`landing-nav${scrolled ? ' landing-nav--scrolled' : ''}`}>
      <div className="landing-container landing-nav-inner">
        <Link to="/login" className="landing-nav-brand" aria-label="FieldCert home">
          <HexLockup iconSize={34} wmSize="xs" gap={10} light />
        </Link>

        <nav className="landing-nav-anchors" aria-label="Page sections">
          {anchors.map(({ id, label }) => (
            <a key={id} className="landing-nav-link" href={`#${id}`}>
              {label}
            </a>
          ))}
        </nav>

        <div className="landing-nav-actions">
          <Link to="/login" className="landing-nav-link landing-nav-signin">
            {signIn}
          </Link>
          <Link to="/login" className="btn btn-primary landing-nav-cta">
            {cta}
          </Link>
        </div>
      </div>
    </header>
  );
}
